import { PropsWithChildren } from "react";
import classes from "./ContentTitle.module.css";

const ContentTitle: React.FC<PropsWithChildren> = (props) => {
  return <div className={classes["content-title"]}>{props.children}</div>;
};

export default ContentTitle;
